import { render, staticRenderFns } from "./UploadReferencesPagePlaceholder.vue?vue&type=template&id=02f1446a&"
import script from "./UploadReferencesPagePlaceholder.vue?vue&type=script&lang=js&"
export * from "./UploadReferencesPagePlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports